import Vue from "vue";
import HelpPanel from "~/components/core/HelpPanel.vue";

// Registro global para no importar el componente en cada página. Cualquier
// .vue puede usar <HelpPanel :title="..."> sin un import explícito.
Vue.component("HelpPanel", HelpPanel);
